import { CSS_WIDE_KEYWORDS } from './css-wide-keywords';
const CSS_COLOR_KEYWORDS = new Set([
    ...CSS_WIDE_KEYWORDS,
    'currentcolor',
    'transparent',
    'black',
    'white',
    'red',
    'green',
    'blue',
    'yellow',
    'orange',
    'purple',
    'pink',
    'gray',
    'grey',
    'brown',
    'cyan',
    'magenta',
    'teal',
    'lime',
    'maroon',
    'navy',
    'olive',
    'silver',
    'aqua',
    'fuchsia',
    'gold',
    'beige',
    'coral',
    'indigo',
    'ivory',
    'khaki',
    'lavender',
    'plum',
    'salmon',
    'tan',
    'tomato',
    'violet',
]);
export function isCssColorKeyword(value) {
    return CSS_COLOR_KEYWORDS.has(value.toLowerCase());
}
export function toKebabCase(value) {
    return value
        .replace(/([a-z0-9])([A-Z])/g, '$1-$2')
        .replace(/([A-Z])([A-Z][a-z])/g, '$1-$2')
        .toLowerCase();
}
export function normalizeColorUtilityClassSuffix(classPrefix, value) {
    const kebabValue = toKebabCase(value);
    const semanticPrefix = classPrefix === 'bg' ? 'background' : classPrefix;
    if (kebabValue === classPrefix || kebabValue === semanticPrefix) {
        return 'default';
    }
    const duplicatedPrefix = `${classPrefix}-`;
    if (kebabValue.startsWith(duplicatedPrefix)) {
        return kebabValue.slice(duplicatedPrefix.length);
    }
    const duplicatedSemanticPrefix = `${semanticPrefix}-`;
    if (kebabValue.startsWith(duplicatedSemanticPrefix)) {
        return kebabValue.slice(duplicatedSemanticPrefix.length);
    }
    return kebabValue;
}
function isTokenLikeIdentifier(value) {
    return /^[a-zA-Z][a-zA-Z0-9-]*$/.test(value);
}
export function hasFlatThemeColorAlias(theme, value) {
    if (!isTokenLikeIdentifier(value) || isCssColorKeyword(value)) {
        return false;
    }
    return typeof theme.colors[value] === 'string';
}
export function isCustomSemanticColorAlias(value) {
    return isTokenLikeIdentifier(value) && !isCssColorKeyword(value);
}
//# sourceMappingURL=color-values.js.map